import { Injectable } from '@angular/core';
import { Barrel } from '../interfaces/barrel';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BarrelCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/barrels/current/' ;
  }

  // Create Barrel
  add(record: Barrel) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Barrel Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Barrels List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Barrel Object
  update(record: Barrel) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Barrel>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Barrel Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
